import React from "react";
import { Medication } from "../../../../messages/MedicationProfile";
import SearchModalResults from "../SearchMedicationResult/SearchMedicationResult";

interface Props {
  medications: Medication[];
  marked: string;
  medicationChosen: (medication: Medication) => void;
}

const SearchMedicationResults = ({ medications, marked, medicationChosen }: Props) => {
  return (
    <div className="SearchMedicationResults">
      {medications.map((medication, index) => (
        <SearchModalResults
          medication={medication}
          marked={marked}
          key={index}
          onClick={medicationChosen}
        />
      ))}
    </div>
  );
};

export default React.memo(SearchMedicationResults);
